<template>
  <v-navigation-drawer
    ref="navdrawer"
    disable-route-watcher
    class="sidebar"
    :class="{ 'sidebar--dark-mode': isDarkMode }"
    v-model="show"
    overlay-opacity="0.3"
    :expand-on-hover="!isMobile"
    :mini-variant="!isMobile"
    :permanent="!isMobile"
    @update:mini-variant="(value) => $store.commit('set', ['sidebarShow', value])"
    app
  >
    <sidebar :minimize.sync="minimize" :items="navItems" :dark.sync="isDarkMode"/>
  </v-navigation-drawer>
</template>

<script>
import { reduce, clone } from "lodash";
const Sidebar = () => import("@/components/Sidebar"); 
export default {
  name: "TheSidebar",
  props: {
    nav: {
      type: Array,
      required: true,
    },
  },
  components: {
    Sidebar,
  },
  mounted() {
    this.$watch(() => {
      if (this.$refs.navdrawer) {
        this.$refs.navdrawer.isMiniVariant,
          (value) => {
            this.isMiniVariant = value;
          };
      }
    });
  },
  data() {
    return {
      isMiniVariant: true,
    };
  },
  computed: {
    show: {
      get: function () {
        return this.$store.state.mode.sidebarShow
      },
      set: function (value) {
        this.$store.commit("set", ["sidebarShow", value])
      },  
    },
    minimize() {
      return this.$store.state.mode.sidebarMinimize
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode
    },
    navItems() {
      const navigation = this.nav.map((item) => {
        let children;
        if(item.children) {
          children = this.getChildren(item.children)
        }
        return { 
          title: item.name,
          path: item.url,
          icon: item.icon,
          children,
        }
      })
      return navigation
    },
  },
  methods: {
    getChildren(list) {
      return reduce(
        list,
        function (result, obj) {
          let res = [];
          if (Array.isArray(result)) {
            res = result;
          }
          if (obj["url"] !== undefined) {
            obj["to"] = clone(obj["url"], true);
            delete obj["url"];
          }
          res.push(obj);
          return res;
        },
        {}
      );
    },
  },
};
</script>

<style lang="scss" src="./TheSidebar.scss" />